module.exports = __webpack_public_path__ + "images/bfdbe7e81e3b52495837e52de1d8b316.png";